export const PROJECT_LISTS = "PROJECT_LISTS"
export const PROJECT_LISTS_SUCCESS = "PROJECT_LISTS_SUCCESS"
export const PROJECT_LISTS_ERROR = "PROJECT_LISTS_ERROR"
// category work report screen
export const WORK_SCREEN = "WORK_SCREEN"
export const WORK_SCREEN_SUCCESS = "WORK_SCREEN_SUCCESS"
export const WORK_SCREEN_ERROR = "WORK_SCREEN_ERROR"
//client screen view 
export const CLIENT_SCREEN = "CLIENT_SCREEN"
export const CLIENT_SCREEN_SUCCESS = "CLIENT_SCREEN_SUCCESS"
export const CLIENT_SCREEN_ERROR = "CLIENT_SCREEN_ERROR"

export const GET_TIMELOGBYDATE = "GET_TIMELOGBYDATE"
export const STORE_TIMELOGBYDATE = "STORE_TIMELOGBYDATE"
export const MOVE_ID_HOURS_TIMELOG = "MOVE_ID_HOURS_TIMELOG"
export const ADD_MANUAL_ENTRY_TIMELOG = "ADD_MANUAL_ENTRY_TIMELOG"
export const CHANGE_STATUS_TIMELOG = "CHANGE_STATUS_TIMELOG"
export const MOVE_ID_HOURS_FROMID = "MOVE_ID_HOURS_FROMID"
export const FLAG_TIMELOG_INVALID = "FLAG_TIMELOG_INVALID"

export const GET_ACTIVITYLOGBYDATE = "GET_ACTIVITYLOGBYDATE"
export const STORE_ACTIVITYLOGBYDATE = "STORE_ACTIVITYLOGBYDATE"